import { ICareProvider } from "../models/ICareProvider";
import { ICareTypeFunction, IReferral, IReferralAttachmentCategory, IReferralShareableInfo, ISaveReferral } from "../models/IReferral";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class ManageReferralApi extends ApiClient {

    getCareProvidersByCareType(id: string, success: (data: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareProvider[]>(`${Utils.LIB_API_BASE_URL}/manageReferral/careProvidersByCareTypeFunction/${id}`, success, error, final);
    }

    getCareTypeFunctions(success: (data: ICareTypeFunction[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICareTypeFunction[]>(`${Utils.LIB_API_BASE_URL}/manageReferral/careTypeFunctions`, success, error, final);
    }

    getReferralAttchmentCategories(success: (data: IReferralAttachmentCategory[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IReferralAttachmentCategory[]>(`${Utils.LIB_API_BASE_URL}/manageReferral/referralAttachmentCategories`, success, error, final);
    }

    saveReferral(data: ISaveReferral, success: (referralId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/manageReferral/`, data, success, error, final);
    }

    sendReferral(data: ISaveReferral, success: (referralId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/manageReferral/send/`, data, success, error, final);
    }

    withdrawReferral(referralId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/manageReferral/withdrawReferral/${referralId}`, undefined, success, error, final);
    }

    copyReferral(referralId: string, success: (copiedData: IReferral) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/manageReferral/copyReferral/${referralId}`, undefined, success, error, final);
    }

    markReferralAsRead(referralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/manageReferral/markAsRead/${referralId}`, undefined, success, error, final);
    }

    forwardReferral(referralId: string, success: (fwdReferralData: IReferral) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/manageReferral/forwardReferral/${referralId}`, undefined, success, error, final);
    }

    shareReferral(referralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/manageReferral/shareReferral/${referralId}`, undefined, success, error, final);
    }

    getShareReferralCareProvider(referralId: number, success: (data: IReferralShareableInfo) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IReferralShareableInfo>(`${Utils.LIB_API_BASE_URL}/manageReferral/shareReferral/${referralId}`, success, error, final);
    }

    deleteReferral(referralId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/manageReferral/deleteReferral/${referralId}`, success, error, final);
    }
}

